import login from "./login";
import user from "./user";


export default  {
    namespaced:true,
    modules:{
        login,
        user
   
    }

}